import { css } from "styled-components";
import token from "styled-token";
import { spaceMixin } from "../spaceMixin";
import { spacingMixin } from "../spacingMixin";
import { typographyMixin } from "../typographyMixin";
import { hoverMediaQueryMixin } from "../hoverMediaQueryMixin";
/** @class CardButtonMixin */

/** @method */

export var CardButtonMixin = function CardButtonMixin(props) {
  return token({
    color: "CardButton.fontColor",
    borderColor: "Card.separatorColor",
    fontType: "CardButton.fontType"
  }, function (_ref) {
    var color = _ref.color,
        borderColor = _ref.borderColor,
        fontType = _ref.fontType;
    return css(["", " color:", ";padding:0;border:0;background:transparent;text-align:center;border-top:1px solid ", ";display:block;width:100%;padding-top:", ";margin-top:", ";cursor:pointer;outline:none;", ";", ""], typographyMixin(Object.assign({
      fontType: fontType
    }, props)), color, borderColor, spaceMixin("sm")(props), spaceMixin("md")(props), hoverMediaQueryMixin("\n                text-decoration: underline;\n            "), spacingMixin(props));
  })(props);
};